<template>
    <Highlighter :treshold="60" :offset="40">
      <slot />
    </Highlighter>
</template>
